import { useEffect, useState } from 'react';
import api from '@/lib/axios';

// Bloco 10 — lê conteúdo publicado do CMS. Conteúdo vazio => usa fallback (texto atual).
// Rascunhos nunca chegam aqui (o público só devolve publicado). Nunca páginas vazias.
export function useCmsContent(grupo) {
  const [content, setContent] = useState({});
  useEffect(() => {
    let alive = true;
    api.get(`/marketplace/cms/content${grupo ? `?grupo=${grupo}&` : '?'}_t=${Date.now()}`)
      .then((r) => { if (alive) setContent(r.data.content || {}); })
      .catch(() => { if (alive) setContent({}); });
    return () => { alive = false; };
  }, [grupo]);
  // cms(key, fallback) => valor publicado não-vazio ou fallback
  const cms = (key, fallback = '') => {
    const v = content[key];
    return (typeof v === 'string' && v.trim()) ? v : fallback;
  };
  return { content, cms };
}

export function useCmsFaqs() {
  const [faqs, setFaqs] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(`/marketplace/cms/faqs?_t=${Date.now()}`)
      .then((r) => { if (alive) setFaqs(r.data.items || []); })
      .catch(() => { if (alive) setFaqs([]); });
    return () => { alive = false; };
  }, []);
  return faqs; // null enquanto carrega; array quando pronto
}
